import { SEO } from "@/components/SEO";
import { headTageTitle } from "@/utils/head-tag-title";
import { getConfigSSR } from "api/config";
import { useMemo } from "react";
import { useAppSelector } from "store/hooks";
import { NextPageWithLayoutAndPageType } from "types/base";
import { ConfigPage } from "types/config";

const Web: NextPageWithLayoutAndPageType = (props: any) => {
  const storeConfig = useAppSelector((state) => state.config);
  const config = props?.config || storeConfig;

  const siteTitleFromHeadTag = useMemo(() => headTageTitle(config), [config]);

  const siteName = siteTitleFromHeadTag
    ? siteTitleFromHeadTag
    : config.company_info?.name;
  const seoconfig = config.pages?.find(
    (page: ConfigPage) => page?.page_type === "home",
  )?.config;

  const description =
    seoconfig?.description ||
    `Book movie tickets online at ${siteName}. Browse movies, check showtimes, and reserve your seats for the latest releases.`;
  const keywords = seoconfig?.keywords || [
    "cinema",
    "movie tickets",
    "movie booking",
    "showtimes",
    siteName,
  ];
  const title = seoconfig?.title || "Home";

  return (
    <SEO
      title={title}
      description={description}
      keywords={keywords}
      siteName={siteName}
    />
  );
};

Web.page_type = "home";

export const getServerSideProps = getConfigSSR;

export default Web;
